export default __webpack_public_path__ + "media/images/premium-icon-739404d558a0375ea7d5a93e5a9610bb.svg";